// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__239t1","addWidgetButton":"Header_addWidgetButton__2_yA1","dashboardTabs":"Header_dashboardTabs__3TK8R","active":"Header_active__34W3C"};